import { render } from "./ImageEditOutline.vue?vue&type=template&id=350be579"
import script from "./ImageEditOutline.vue?vue&type=script&lang=js"
export * from "./ImageEditOutline.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ImageEditOutline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "350be579"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('350be579', __exports__)) {
    api.reload('350be579', __exports__)
  }
  
  module.hot.accept("./ImageEditOutline.vue?vue&type=template&id=350be579", () => {
    api.rerender('350be579', render)
  })

}


export default __exports__